import { Toggle } from '@talentmesh/ui/components/toggle';
import { cn } from '@talentmesh/ui/lib/utils';

const ToggleButton = ({ className, children, onMouseDown, ...props }: React.ComponentProps<typeof Toggle>) => (
    <Toggle
        size="sm"
        className={cn('text-muted-foreground aria-pressed:bg-primary/10', className)}
        onMouseDown={(event) => {
            // Keep the editor selection when interacting with the toolbar.
            event.preventDefault();
            onMouseDown?.(event);
        }}
        {...props}
    >
        {children}
    </Toggle>
);

export default ToggleButton;
